import { ContactCell as ContactTableCell } from '@equip.health/ui';

const ContactCell = ({
  inquiryId,
  primaryContact,
}: {
  inquiryId: string;
  primaryContact: InquiryListItemResponse['primaryContact'];
}) => {
  const {
    email: contactEmail,
    firstName: contactFirstName,
    lastName: contactLastName,
    phoneNumber: contactPhoneNumber,
    chosenName: contactChosenName,
    relationToPatient,
  } = primaryContact;

  return (
    <ContactTableCell
      chosenName={contactChosenName}
      email={contactEmail}
      firstName={contactFirstName}
      id={`inquiry-${inquiryId}`}
      lastName={contactLastName}
      phoneNumber={contactPhoneNumber}
      relationToPatient={relationToPatient}
    />
  );
};
export default ContactCell;
